import {
  Component,
  EventEmitter,
  HostBinding,
  Input,
  OnInit,
  Output,
} from "@angular/core";
import { DateTime } from "luxon";
import { IProject } from "src/app/admin/projects/shared/models/IProject";
import { IUser } from "src/app/admin/users/models/IUser";

import {
  CalendarDay,
  CalendarProjectDay,
} from "src/app/timetracking/models/CalendarCell";
import { ITimeEntry } from "src/app/timetracking/models/ITimeEntry";

enum CalendarView {
  Details,
  QuickEdit,
}

@Component({
  selector: "app-calendar-day",
  templateUrl: "./calendar-day.component.html",
  styleUrls: ["./calendar-day.component.scss"],
})
export class CalendarDayComponent implements OnInit {
  @Input() user: IUser;
  @Input() calendarDay: CalendarDay;
  @Input() project: IProject;
  @Input() projectDay: CalendarProjectDay;
  @Input() canEditDay: boolean;

  @HostBinding("class.exception")
  get hasException(): boolean {
    if (!this.calendarDay) {
      return false;
    }
    return this.calendarDay.isLocked && this.calendarDay.hasException;
  }
  @HostBinding("class.locked")
  get isLocked(): boolean {
    if (!this.calendarDay) {
      return false;
    }
    return this.calendarDay.isLocked && !this.calendarDay.hasException;
  }
  @HostBinding("class.today")
  get isToday(): boolean {
    if (!this.calendarDay) {
      return false;
    }
    return this.calendarDay.isToday;
  }
  @HostBinding("class.weekend")
  get isWeekend(): boolean {
    if (!this.calendarDay) {
      return false;
    }
    return this.calendarDay.isWeekend;
  }
  @HostBinding("class.future")
  get isFuture(): boolean {
    return (
      this.calendarDay &&
      this.calendarDay.date.endOf("day") > DateTime.local().endOf("day")
    );
  }

  @Output() addEntryForDay = new EventEmitter();
  @Output() viewEntriesForDay = new EventEmitter();
  @Output() quickEditStart = new EventEmitter();
  @Output() quickEditEnd = new EventEmitter();

  CalendarView = CalendarView;
  selectedView = CalendarView.Details;
  get canEdit(): boolean {
    return (
      this.canEditDay &&
      this.calendarDay &&
      this.calendarDay.canEdit &&
      this.calendarDay.date.endOf("day") <= DateTime.local().endOf("day")
    );
  }
  get canQuickEditEntry(): boolean {
    if (
      this.projectDay &&
      this.projectDay.timeEntries &&
      this.projectDay.timeEntries.length < 2
    ) {
      return true;
    }
    return false;
  }
  get quickEditEntry(): ITimeEntry {
    if (!this.projectDay) {
      return null;
    }
    return (
      this.projectDay.timeEntries[0] || {
        id: 0,
        userId: this.user.id,
        entryDate: DateTime.local().toUTC(),
        entryDateIso: DateTime.local().toISO(),
        projectId: this.project.id,
        workOrderId: null,
        workDay: this.calendarDay.date,
        workDayIso: this.calendarDay.date.toFormat("yyyy-MM-dd"),
        forThirdParty: false,
        timeSpentMinutes: 0,
        isLocked: false,
        usesBuiltInTime: false,
      }
    );
  }

  constructor() {}

  ngOnInit() {}

  edit() {
    const project = this.project;
    const day = this.projectDay.date;
    if (this.projectDay.totalTime > 0) {
      this.viewEntriesForDay.emit({ project, day });
    } else if (this.calendarDay.canEdit) {
      this.addEntryForDay.emit({ project, day });
    } else {
      // TODO show an alert modal
      alert("locked! cant do anything");
    }
  }
  quickEdit() {
    if (!this.canQuickEditEntry) {
      return false;
    }
    this.openQuickEdit();
  }
  quickEditSaved() {
    this.closeQuickEdit();
  }
  quickEditCancelled() {
    this.closeQuickEdit();
  }

  private openQuickEdit() {
    this.quickEditStart.emit();
    this.selectedView = CalendarView.QuickEdit;
  }
  private closeQuickEdit() {
    this.quickEditEnd.emit();
    this.selectedView = CalendarView.Details;
  }
}
